import {
    createTheme, Grid, IconButton, MuiThemeProvider,
    TextFieldProps,
    Typography
} from '@material-ui/core'
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons'
import MUIDataTable from 'mui-datatables'
import { useSnackbar } from 'notistack'
import React, { useRef, useState } from 'react'
import { useFieldArray } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import SelectUser from '../../../components/Form/SelectUser'
import AlertDialog from '../../../components/ui/AlertDialog'
import ButtonUI from '../../../components/ui/ButtonUI'
import LoadingUI from '../../../components/ui/LoadingUI'
import { useStyles } from './Style'

type props =  any;

const ResponsibleUserList: React.FC<props> = ({ control, name, allowAdd, allowDelete }) => {
    const classes = useStyles()
    const { t: tGeneral } = useTranslation("General")
    const { t: tShed } = useTranslation("Shed")
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false)
    const [responsibleUser, setResponsibleUser] = useState<any>(null)
    const txtUserInputRef = useRef<HTMLInputElement>(null);

    const { fields, append, remove } = useFieldArray({ control, name: name })

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            }
        }
    })

    const columns = [
        {
            name: 'shedId',
            options: {
                display: false,
            }
        },    
        {
            name: 'responsibleUserName',
            label: tShed("userName"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    display: false,
                    }),
                setCellProps: () => ({
                    align: "left"
                }),
            }
        },  
        {
            name: "",
            options: {
                setCellHeaderProps: () => ({
                    align: "right",
                    }),
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(tableMeta.rowData[0], tableMeta.rowIndex)
                )
            }
        },
    ]

    const renderButtons = (shedId: any, rowIndex: any) => {

        let justAdded = shedId === 0;

        if ((allowAdd && justAdded) || allowDelete)
            return (
                <AlertDialog
                dialogTitle={tGeneral("dialogDeleteTitle")}
                dialogContentText={tGeneral("dialogDeleteContentText")}
                cancelTextButton={tGeneral("cancel")}
                confirmTextButton={tGeneral("confirm")}
                confirmDialogFunction={() => { removeItemFromList(rowIndex) }}
                Button={
                    <IconButton size='small' edge="end" >
                        <DeleteIcon />
                    </IconButton>
                }
            />
            )
        else
            return (<></>)
    }

    const removeItemFromList = (rowIndex: any) => {
        remove(rowIndex);
    }

    const addItemToList = async () => {
        setLoading(true)
        
        if (!responsibleUser || responsibleUser.code === '') {
            enqueueSnackbar(tShed("responsibleUserMustBeInformed"), { variant: 'warning' })
            setLoading(false)
            return
        }

        var data = {
            shedId: 0,
            responsibleUser: responsibleUser.code,
            responsibleUserName: responsibleUser.label
        }

        

        var existingItem = false
        fields.forEach((field) => {
            if ((field as any).responsibleUser === data.responsibleUser){
                existingItem = true
            }
        })

        if (existingItem) {
            enqueueSnackbar(tShed("itemAlreadyOnList"), { variant: 'warning' })
            setLoading(false)
        return
        }

        

        append(data);
        setLoading(false);
        
        //Resetar o campo txt:
        setResponsibleUser(null);
        window.setTimeout(() => { if (txtUserInputRef.current !== null) txtUserInputRef.current.value = ''; }, 10);
    }

    const gridOptions = {
        textLabels: {
            body: {
                noMatch: tGeneral('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: tGeneral("next"),
                previous: tGeneral("previous"),
                rowsPerPage: tGeneral("rowsPerPage") + ":",
                displayRows: tGeneral("of"),
            }
        }
    }

    return (
        <Grid style={{ marginTop: 20, width: "98%", marginLeft: 10, marginBottom: 10 }}>
            <Typography className={classes.root} style={{ marginLeft: 10 }} >
                {tShed("responsibleUsers")}
            </Typography>
            {!allowAdd ? <Grid /> :
                <Grid container spacing={1} style={{ marginBottom: 10 }}>
                    <Grid item xs={9}>
                        <SelectUser
                            label={tShed("responsibleUser")} 
                            name="responsibleUser"
                            control={control} 
                            fullWidth
                            multiple={true}
                            onChange={setResponsibleUser}
                            includeSupplierUsers={false}
                            inputRef={txtUserInputRef}
                            onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                if (e.key === 'Enter')
                                    addItemToList();
                            }}
                            />
                    </Grid>

                    <Grid item xs={1}>
                        <ButtonUI
                            onClick={() => addItemToList()}
                            color="primary"
                            variant="contained"
                            onKeyDown={(e: React.KeyboardEvent<HTMLElement>) => {
                                if (e.key === 'Enter')
                                    addItemToList();
                            }}
                            style={{ maxWidth: '40px', maxHeight: '38px', minWidth: '40px', minHeight: '38px', marginTop: 20, marginLeft: 12   }}>
                            <AddIcon />
                        </ButtonUI>
                    </Grid>
                </Grid>
            }
            {loading ? <LoadingUI /> :
                <Grid style={{ marginLeft: 10 }} >
                    <MuiThemeProvider theme={myTheme}>
                        <MUIDataTable
                            title=''
                            data={fields}
                            columns={columns}
                            options={{
                                ...gridOptions,
                                serverSide: false,
                                pagination: false,
                                sort: false,
                                selectToolbarPlacement: "none",
                                filter: false,
                                search: false,
                                download: false,
                                print: false,
                                viewColumns: false,
                                selectableRows: 'none',

                            }} />
                    </MuiThemeProvider>
                </Grid>
            }
        </Grid>
    )
}

export default ResponsibleUserList